import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, User, AbsenceCause } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { AssenzeService } from '../service/assenze.service';
import { UserService } from '../service/user.service';
import { AppConstants } from '../core/app.constants';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-detail-assenze',
  templateUrl: './detail-assenze.component.html',
  styleUrls: ['./detail-assenze.component.css'],
  host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class DetailAssenzeComponent extends BaseComponent implements OnInit 
{
    static DIALOG_ID: string = "detailAssenzeDialog";
    it: any = AppConstants.ITA_CALENDAR_CONF;
    userContext: UserContext;
    infoMessage: string;
    errorMessage: string;
    
    userSelected: SelectItem = null;
    filterUsers: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    
    hoursSelected: number = 8;
    hours: SelectItem[] = [];
    
    causes: AbsenceCause[] = [];
    causeItems: SelectItem[] = [];
    causeSelected: number = null;

    fromDate: Date = null;
    toDate: Date = null;

   constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private assenzeService: AssenzeService,
            private userService: UserService) {
        super(authAccess, router, messageProvider);
    }
    
  ngOnInit() {
      this.userContext = this.authAccess.getUserContext();
      if(this.userContext == null) {    
          this.authAccess.invalidate();
      } else {
          this.hours.push({label: "Un'ora", value: 1});
          this.hours.push({label: "2 ore", value: 2});
          this.hours.push({label: "3 ore", value: 3});
          this.hours.push({label: "4 ore", value: 4});
          this.hours.push({label: "5 ore", value: 5});
          this.hours.push({label: "6 ore", value: 6});
          this.hours.push({label: "7 ore", value: 7});
          this.hours.push({label: "8 ore", value: 8});
          this.hoursSelected = 8;
          this.init();
          this.assenzeService.getAssenzeDetailStatus().subscribe(
            operation => {
                if (operation.status == "open") {
                    this.errorMessage = null;
                    this.infoMessage = null;
                    if (operation.date != null) {
                        this.fromDate = operation.date;
                        this.toDate   = operation.date;
                        this.reset(false);
                    } else {
                        this.reset(true);
                    }
                    $("#" + DetailAssenzeComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
                }
            }
          );    
      }
  }

  private init() {
      this.reset(true);
      let obs: Observable<any>[] = [];
      obs.push(this.assenzeService.getAbsenceCauses(this.userContext.srmToken));
      obs.push(this.userService.getUsers(this.userContext.srmToken));    
      Observable.forkJoin(obs).subscribe(
        results => {
            this.causes = results[0].absenceCauses;
            let users: User[] = results[1].users;

            for(let i = 0; i < this.causes.length; ++i) {
                let current = this.causes[i];                
                this.causeItems.push({label: current.description, value: current.id});
            }
            if(this.causes.length > 0) {
                this.causeSelected = this.causeItems[0].value;
            }
            for(var i = 0; i < users.length; ++i) {
                var current: User = users[i];
                this.filterUsers.push({label:current.fullname, value: current.id});
            }
    
        },
        error => {
            this.handleError(error);
        }
      );

  }
  
  reset(full: boolean) {
    if (full) {
        this.fromDate = new Date();
        this.toDate = new Date();
    }
    this.userSelected = null;
    this.hoursSelected = 8;
    if (this.causes.length > 0) {
        this.causeSelected = this.causeItems[0].value;
    }
    this.errorMessage = null;
    this.infoMessage = null;
  }
  
  insert(more: boolean) {
    this.infoMessage = null;
    this.errorMessage = null;
    
    if(this.userSelected == null || this.userSelected.value == null) {
        this.errorMessage = "Inserire l'utente";
        return;
    }
    if(this.fromDate > this.toDate) {
        this.errorMessage = "Data di fine periodo antecedente alla data di inizio";
        return;
    }
    this.assenzeService.insertAssenze(this.userContext.srmToken, this.userSelected.value, 
        this.fromDate, this.toDate, this.causeSelected, this.hoursSelected).subscribe(
        result => {
            let msg = "Inserimento eseguito correttamente";
            if(!more) {
                this.messageProvider.notifyMessage(msg);
                this.close();
            } else {
                this.reset(false);
                this.infoMessage = msg;
            }
            this.assenzeService.fireRefreshEvent();
        },
        error => {
            this.errorMessage = this.retrieveError(error);
        }
    );
  }
  
  filterUser(event) {
    this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
  }

  changeDateStart() { 
    if (this.fromDate > this.toDate) {
        this.toDate = this.fromDate;
    }
  }
  
  close() {
    $("#" + DetailAssenzeComponent.DIALOG_ID).modal("hide");
  }
  
  shortcutHandler(event) { 
    if (event.keyCode == 27) { // ESC
        this.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/detail-assenze/detail-assenze.component.ts